<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple" v-preventReClick @click="handleDelete">
            删除
          </el-button>

          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData" v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
            <el-table-column prop="operation" fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
                <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column fixed type="selection" :reserve-selection="true" width="55" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" prop="deptName" label="科室名称"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="warehouseName" label="请领目标库房"></el-table-column>
        <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" prop="productName" label="产品名称"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" prop="specName" label="规格型号"></el-table-column>
        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames">
          <template slot-scope="scope">
            {{ scope.row.approverNames?scope.row.approverNames:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="80" prop="unit" label="最小单位"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" prop="manufacturerName" label="生产厂家"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" prop="supplierName" label="供应商"></el-table-column>
        <el-table-column min-width="80" prop="purchasePrice" label="采购价"></el-table-column>
        <el-table-column min-width="80" prop="billingPrice" label="计费价"></el-table-column>
        <!-- <el-table-column min-width="80" prop="brand" label="品牌"></el-table-column> -->
        <el-table-column min-width="80" prop="stockCategoryName" label="库存类型"></el-table-column>
        <el-table-column min-width="80" prop="isCompareCode" label="对码状态"></el-table-column>
        <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>
        <el-table-column prop="operation" fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
     </div>

 

      <el-dialog :title="title + route.menuName" :visible.sync="open" :center="true" width="1100px" :before-close="cancel" :close-on-click-modal="false" @close="closeEvt">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item prop="deptName" label="科室">



                <el-select v-if="system_setting.IsUseWard" v-model="form.deptName" placeholder="请选择"
                  :disabled="!editMode" style="width: 100%" filterable :filter-method="getWarehousesDeptWards"
                  @change="applyDeptChange1">
                  <el-option v-for="item in STATIC_Depts" :key="item.idGroup"
                    :label="item.deptNo+' '+item.deptName + ' ' + (item.wardName ? item.wardName : '')" :value="item.idGroup"></el-option>
                </el-select>

                <el-select v-else :disabled="!editMode" v-model="form.deptName" filterable :filter-method="getDepts" placeholder="请选择科室" style="width: 100%" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no+' '+item.name" :value="item.id"></el-option>
                  
                </el-select>


        


              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="warehouseName" label="请领目标库房">
                <el-select :disabled="!editMode" v-model="form.warehouseName" filterable :filter-method="getWarehouseList" placeholder="请选择库房" style="width: 100%" @change="warehouseChange">
                  <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="supplierProductNo" label="供应商产品编码">
                <el-input disabled v-model="form.supplierProductNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="supplierProductId" label="供货商产品">
                <!-- <SelectTable :disabled="!editMode" :columns="supplierProductColumns" :placeholder="'请选择产品'" :innerName="form.productName" :dataList="STATIC_SupplierProducts" @querySubmit="getProductList" @change="productChange" :filterable="false" :filterOptions="supplierProductFilterOptions" /> -->
                <SelectScrollTable :disabled="!editMode" :innerName="form.productName" :columns="supplierProductColumns" style="width: 100%" :filterMethod="GetSupplierProducts" :otherQuery="productQuery" @change="productChange"></SelectScrollTable>
                <!-- :dataList="STATIC_SupplierProducts" -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="specName" label="规格型号">
                <el-input disabled v-model="form.specName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="manufacturerName" label="生产厂家">
                <el-input disabled v-model="form.manufacturerName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="unit" label="最小单位">
                <el-input disabled v-model="form.unit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="brand" label="品牌">
                <el-input disabled v-model="form.brand"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="stockCategory" label="库存类型">
                <el-radio-group :disabled="!editMode" v-model="form.stockCategory">
                  <el-radio :label="0">普通库存</el-radio>
                  <el-radio :label="1">备货库存</el-radio>
                  <el-radio :label="2">跟台库存</el-radio>
                  <el-radio :label="3">其他</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
                <el-input disabled v-model="form.medicalInsuranceCategoryNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注">
                <el-input :disabled="!editMode" v-model="form.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>

        </el-form>
        <div slot="footer" class="dialog-footer">


          <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
          <!-- <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button> -->
          <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
          <el-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</el-button>
          <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
          <!--el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <el-button class="btn primary" v-if="editMode" type="primary" size="small" v-preventReClick @click="submit">确 定</el-button> -->
        </div>
      </el-dialog>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetDeptProducts,
  RemoveDeptProduct,
  SaveDeptProduct,
  GetAutoPurchaseApplySettingByProductInfo,
  GetSupplierProducts,
  RejectDeptProduct,
  ExportDeptProduct
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import SelectTable from "@/components/select-table";
import SelectScrollTable from "@/components/select-scroll-table";
import SelectFilter from "@/components/table-select-filter";
import ApproveInfo from "@/components/approve-info";
import { StockCategoryOptions } from "@/enum";
export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    // SelectTree
    SelectTable,
    SelectFilter,
    SelectScrollTable,
    ApproveInfo
  },
  data () {
    return {
      exportAction:ExportDeptProduct,
      GetSupplierProducts: GetSupplierProducts,
      StockCategoryOptions: StockCategoryOptions,
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
        orgCode :sessionStorage.getItem('orgId')
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      editMode: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      rules: {
        deptName: [{ required: true, message: "请选择科室", trigger: "blur" }],
        warehouseName: [{ required: true, message: "请选择一级库房", trigger: "blur" }],
        supplierProductId: [
          { required: true, message: "请选择供应商产品", trigger: "blur" },
        ],
      },
      filterOptions: [
        {
          name: "供货商产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "供应商",
          type: "input",
          code: "supplierName",
        },
        {
          name: "科室",
          type: "select",
          code: "deptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "库存类型",
          type: "select",
          code: "stockCategory",
          data: StockCategoryOptions,
        },
      ],
      oldStockCategory: 0,
      reject: RejectDeptProduct,
      productQuery: {
        isEnabled: 1,
        status: 2,
        isRestricTemp:1
      },
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData () {
      this.loading = true;
      GetDeptProducts(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 新建
    handleAdd () {
      this.open = true;
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
      this.showWorkFlowInfo = false

    },
    handleInfo (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      if(row.status == 1){
        this.form.result = 1

        this.$route.query.formMode = 3
      }
      this.initWorkFlowProperty(this.form)
      
      this.open = true;
      this.editMode = false;
      this.oldStockCategory = this.form.stockCategory;
    },
    // 编辑
    handleUpdate (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.title = "编辑";
      this.editMode = true;
      this.oldStockCategory = this.form.stockCategory;
      this.getWarehouseList("");
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }

        const promises = [
          GetDeptProducts({
            supplierProductId: this.form.supplierProductId,
            deptId: this.form.deptId,
            orgCode :sessionStorage.getItem('orgId'),
            IsDeptId: 0,
          }),
          GetAutoPurchaseApplySettingByProductInfo({
            deptId: this.form.deptId,
            supplierProductId: this.form.supplierProductId,
            warehouseId: this.form.warehouseId,
          }),
        ];
        Promise.all(promises).then((results) => {
          // 所有请求都完成后执行下一个方法
          const [deptProductData, autoApplyData] = results;
          // console.log(deptProductData, autoApplyData)
          if (deptProductData.returnData && deptProductData.returnData.data.length > 0) {
            const h = this.$createElement;
            let content = [
              h(
                "p",
                `该产品的库存类型之前已被[${deptProductData.returnData.data[0].deptName}],维护为[${deptProductData.returnData.data[0].stockCategoryName}],是否继续您当前的选择?`
              ),
            ];

            this.$confirm("提示", {
              title: "同产品不同的库存类型？",
              type: "warning",
              message: h("div", content),
            }).then(() => {
              //点确定时的操作
              if (this.oldStockCategory != this.form.stockCategory) {
                if (autoApplyData.returnData && autoApplyData.returnData.length > 0) {
                  this.$my_confirm(
                    "该产品已设置自动申领，慎重修改库存类型，修改后将以最新的库存类型自动申领",
                    "提示",
                    {
                      type: "warning",
                    }
                  ).then(() => {
                    this.save();
                  });
                } else {
                  this.save();
                }
              } else {
                this.save();
              }
            });
          } else {
            this.save();
          }
        });
      });
    },
    save () {
      SaveDeptProduct(this.form).then((res) => {
        this.form = {}
        this.open = false;
        this.$my_message(`执行成功`, "success");
        this.getData();
      }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
    },
    resetForm () {

        let DeptName =  this.mySessionStorage.getDeptName()?this.mySessionStorage.getDeptName():''
        let WardName = this.mySessionStorage.getWardName()?this.mySessionStorage.getWardName():''
      this.form = {
        id: 0,
        deptName: this.system_setting.IsUseWard?`${DeptName} ${WardName} `:DeptName,
        deptId: this.mySessionStorage.getDeptId(),
        wardId : this.system_setting.IsUseWard?this.mySessionStorage.getWardId():'',
        supplierProductId: "",
        stockCategory: 0,
        remark: "",
        productName: "",
        warehouseName: '',
        productId: "",
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.system_setting.IsUseWard) {
        this.getWarehousesDeptWards()
      } else {
        this.getDepts("");
      }
      
      this.getWarehouseList("");
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveDeptProduct({
            ids,
          });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    filterChange (query) {
      window.console.log(query);
      this.query = Object.assign(this.query, query);
      this.getData();
    },

    productChange (row) {
      let id = this.form.id;
      this.form = Object.assign(this.form, row);
      this.form.id = id;
      this.form.unit = this.form.minUnit;
      this.form.supplierProductId = row.id;
      this.form.supplierProductNo = this.form.no;
      this.form.remark = "";
      this.form.warehouseName = row.onelevelWarehouseName;
      this.form.warehouseId = row.onelevelWarehouseId;

      this.$refs.form.validateField("supplierProductId");
    },
    warehouseChange (val) {
      this.form.warehouseId = val;
      var arr = this.STATIC_OneLevelWarehouses.filter(e => e.id == val);
      this.form.warehouseName = arr[0].name;
      this.$forceUpdate();
    },
    deptChange (val) {
      this.form.deptId = val;
      var arr = this.STATIC_Depts.filter((e) => e.id == val);
      this.form.deptName = arr[0].name;
      this.getWarehouseList("");
      // this.getProductList();
    },
    applyDeptChange1(val){
      let arr = this.STATIC_Depts.filter(res=>res.idGroup == val)
      this.form.deptName =  arr[0].deptName + " " + (arr[0].wardName?arr[0].wardName:'');
      this.form.deptId = arr[0].deptId
      this.form.wardId = arr[0].wardId
      this.getWarehouseList("");
    },
    getProductList (query) {
      query.isEnabled = 1;
      query.status = 2;
      query.pageIndex = 1;
      query.pageSize = 50;
      query.onelevelWarehouseIdsByDeptId = this.form.deptId;
      this.getSupplierProducts(query);
      //   {
      //   keyWord: keyWord,
      //   isEnabled: 1,
      //   status: 2
      // })
    },
    getWarehouseList (keyWord) {
      if (this.form.deptId) {
        this.getOneLevelWarehousesByOneLevelDeptId(keyWord, this.form.deptId);
      } else {
        this.STATIC_OneLevelWarehouses = [];
      }
    },
    closeEvt(){
      this.form = {}

    }
  },
  mounted () {
    this.getData();
    // this.getOneLevelWarehouses("");
 
    
    // this.getProductList();
  },
};
</script>

<style lang="scss" scoped></style>
